import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfilesList from "examples/Lists/ProfilesList";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";

import profilesListData from "layouts/profile/data/profilesListData";

import homeDecor1 from "assets/images/home-decor-1.jpg";
import homeDecor2 from "assets/images/home-decor-2.jpg";
import homeDecor3 from "assets/images/home-decor-3.jpg";
import homeDecor4 from "assets/images/home-decor-4.jpeg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

import ProfileDescription from "../../profile/components/ProfileDescription";
import StudentQuickProfile from "layouts/profile/components/StudentQuickProfile";
import CryptoJS from "crypto-js";

function Profile() {
  const AES_KEY = "7D3B8E69F1A84B7EA8A3F6792B44C926";
  const AES_IV = "A1B2C3D4E5F60718";

  const decryptText = (encryptedText) => {
    const key = CryptoJS.enc.Utf8.parse(AES_KEY);
    const iv = CryptoJS.enc.Utf8.parse(AES_IV);
    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  };

  let studentId = null;
  let token = null;

  const encrypted = localStorage.getItem("UserLogDetails");
  if (encrypted) {
    const decryptedUser = decryptText(encrypted);
    if (decryptedUser) {
      const parsed = JSON.parse(decryptedUser);
      studentId = parsed.StudentId;
      token = parsed.Token;
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={3}>
            {/* Platform Settings */}
            <Grid item xs={12} md={6} xl={4}>
              <PlatformSettings />
            </Grid>

            {/* Profile Description and StudentQuickProfile */}
            <Grid item xs={12} md={6} xl={8}>
              <MDBox display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2}>
                <MDBox flex={1}>
                  <ProfileDescription studentId={studentId} token={token} />
                </MDBox>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ display: { xs: "none", md: "block" } }}
                />
                <MDBox flex={1}>
                  <StudentQuickProfile studentId={studentId} token={token} />
                </MDBox>
              </MDBox>
            </Grid>            
          </Grid>
        </MDBox>            
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Profile;
